// import Scroller from './modules/Scroller'
// import Marquee from './modules/Marquee'
// import Slider from './modules/Slider'

import Highway from '@dogstudio/highway'
import modular from 'modujs'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { classesInjection, playIntro, resetIntro } from './utils/transitions'
import { Fade } from './modules/Transitions'
import Scroller from './modules/Scroller'
import * as modules from './modules'

const app = new modular({
  modules,
})

// new Slider()
// new Marquee()
var scroller
class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted() {
    app.init(app)
  }

  onLeave() {
    // console.log('on leave, cleaning scroll trigger')
    app.destroy()
    scroller.reset()
    ScrollTrigger.getAll().forEach((trigger) => {
      trigger.kill()
    })
  }
}

const init = () => {
  classesInjection()
  playIntro()

  scroller = new Scroller()

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer,
    },
    transitions: {
      default: Fade,
    },
  })

  window.H = H
}

document.addEventListener('DOMContentLoaded', init)

const args = [
  '\n%c Made with ♥ by Stoëmp Studio - https://stoempstudio.com %c\n',
  'display: block; padding: 5px 10px; background: #141414; line-height: 40px; color: #ffffff;',
  'background: #fff;',
]
window.console.log.apply(console, args)
